import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import {Auth} from "./utils/Auth";
import {AppContext} from "./utils/MainContext";
import useShowHeaderFooter from "./utils/useShowHeaderFooter";
import {GoogleOAuthProvider} from "@react-oauth/google";
import {$api} from "./api/api";
import Root from "./root/Root";

const App = () => {
    const pageUrl = useLocation();

    useEffect(() => {
        if (pageUrl.pathname === "/settings") {
            document.body.bgColor = "#fbfbfb";
        }
    }, [pageUrl.pathname]);

    return (
        <Auth>
            <AppContext>
                <GoogleOAuthProvider clientId={$api("google_client")}>
                    {useShowHeaderFooter(pageUrl) && <Header/>}
                    <Root/>
                    {useShowHeaderFooter(pageUrl) && <Footer/>}
                </GoogleOAuthProvider>
            </AppContext>
        </Auth>
    );
};

export default App;
